export const init = () => {
  // Check if container exists & init slider
  const slickInformations = $('.slick-informations');
  if (slickInformations.length === 0) return;

  slickInformations.slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    useCSS: true,
    useTransform: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: cube.constants.breakpointSm,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
};



// WEBPACK FOOTER //
// ./src/homepage/sliders/home-slider-informations.js